import { render, staticRenderFns } from "./dbWaitingArea.vue?vue&type=template&id=3ce089ae&scoped=true"
import script from "./dbWaitingArea.vue?vue&type=script&lang=js"
export * from "./dbWaitingArea.vue?vue&type=script&lang=js"
import style0 from "./dbWaitingArea.vue?vue&type=style&index=0&id=3ce089ae&prod&lang=css"
import style1 from "./dbWaitingArea.vue?vue&type=style&index=1&id=3ce089ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce089ae",
  null
  
)

export default component.exports